import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { getTerminalRequestCode, getTerminalRequestCodeResponse } from "./TIDHandlingData/GetTerminalRequestCode";

const languageMap = {
    curl: 'bash',
    java: 'java',
    "C#": 'csharp',
    python: 'python',
    JavaScript: 'javascript'
};

const GetTerminalRequestComponent = () => {
    const [selectedLanguageGetTerminalRequest, setSelectedLanguageGetTerminalRequest] = useState('curl');
    const [copyStatus, setCopyStatus] = useState({ type: '', isCopied: false });

    const handleSelectedCode = (language) => {
        setSelectedLanguageGetTerminalRequest(language);
    };

    const handleCopyClick = (type) => {
        const textToCopy = type === 'getTerminalRequest' ? getTerminalRequestCode[selectedLanguageGetTerminalRequest].request : getTerminalRequestCodeResponse;
        navigator.clipboard.writeText(textToCopy)
        .then(() => {
            setCopyStatus({ type, isCopied: true });
            setTimeout(() => {
                setCopyStatus({ type: '', isCopied: false });
            }, 1000);
        })
        .catch((error) => {
            console.error('Error copying text: ', error);
            alert('Failed to copy text. Please try again.');
        });
};

    return (
        <section className="docs-section" id="onboard-terminal">
                <div className="row flexbox">
                    <div className="col-md-5">
                        <h2 className="section-heading">Get TerminalId Request</h2>
                        <p><span className="badge badge-secondary back-green">POST</span><span className="api"> /getTerminalId</span></p>
                        <p>Service to provide free terminalId for storeId and ecrId</p>

                        <h4>Request Body</h4>

                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">storeId</span> &nbsp; &nbsp; <b>string</b></p>
                            <p className="description">Store Id, The id is used when you on-board store in the westpay access portal.</p>
                        </div>
                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">ecrId</span> &nbsp; &nbsp; <b>string</b></p>
                            <p className="description">ECR Id, The id is used to uniquely indentify specific ECR in your store.</p>
                        </div>

                        <br />

                        <div className="response-codes">

                            <h4>Response Codes</h4>

                            <div className="table-wrapper">

                                <h6 className="header">HTTP Status code summary</h6>

                                <table>
                                    <tbody>
                                        <tr>
                                            <td>200 Success</td>
                                            <td>Get terminalid request was successful.</td>
                                        </tr>
                                        <tr>
                                            <td>400 Bad Request</td>
                                            <td>Bad request format or validation failed for incorrect data formats.</td>
                                        </tr>
                                        <tr>
                                            <td>401 Unauthorized</td>
                                            <td>Request requires authentication, and the provided credentials are either missing, invalid, or insufficient, hence send a valid merchant access token (Bearer) issued by Westpay in the "Authorization" header.</td>
                                        </tr>
                                        <tr>
                                            <td>404 Resources not found</td>
                                            <td>If request cannot find data for provided data.</td>
                                        </tr>
                                        <tr>
                                            <td>422 Unprocessable entity</td>
                                            <td>Indicates that the server understands the request but cannot process it due to semantic errors or invalid data in the request payload.</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>

                    </div>

                    <div className="col-md-7 code-segments">
                    <div className="docs-code-block">
                        <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Request</span>
                                        {Object.keys(getTerminalRequestCode).map(language => (
                                            <React.Fragment key={language}>
                                                <input type="radio" name="langGetTerminalRequest" id={`${language}GetTerminalRequest`} onClick={() => handleSelectedCode(language)} checked={selectedLanguageGetTerminalRequest === language} />
                                                <label htmlFor={`${language}GetTerminalRequest`} className="language">{language}</label>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'getTerminalRequest' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("getTerminalRequest")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'getTerminalRequest' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language={languageMap[selectedLanguageGetTerminalRequest]} style={dracula} showLineNumbers>
                                        {getTerminalRequestCode[selectedLanguageGetTerminalRequest].request}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                    <div className="docs-code-block">
                        <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Response</span>
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'getTerminalRequestResponse' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("getTerminalRequestResponse")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'getTerminalRequestResponse' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language="json" style={dracula} showLineNumbers>
                                        {getTerminalRequestCodeResponse}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                </div>
                </div>
            </section>
    );
};

export default GetTerminalRequestComponent;
